import { $asyncGet, wssUrl } from '../common.js';
// import { getKey } from '@/js/public.js';
// import {}

/**
 * 客服登录
 * @param {string} device_id 设备号
 * @param {string} merchant_id 店铺id
 * @returns
 */
export function agentLogin(device_id = "001", merchant_id = localStorage.getItem("merchant_id")) {
  const encryptedToken = localStorage.getItem("access_token")

  return `${wssUrl}/v3/merchant/customerservice/Chat/AgentLogin?merchant_id=${merchant_id}&device_id=${device_id}&access_token=${encryptedToken}`
}

/**
 * 客服获取到聊天列表
 * v3/merchant/customerservice/Chat/ChatList
 */
export function getChatList() {
  return $asyncGet(`v3/merchant/customerservice/Chat/ChatList?merchant_id=${localStorage.getItem("merchant_id")}`);
}
/* export const $webSocket = async function () {
  return new WebSocket(agentLogin());
} */